import React from 'react';
import clsx from 'clsx';
import Lottie from 'lottie-react';

import Section from '@common/Section';
import Container from '@common/Container';
import Button from '@common/Button';

import { BLOCKS } from '@contentful/rich-text-types';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

import btsSummitLogoAnimation from '@images/bts-summit-logo.json';

import * as styles from './video.module.scss';

const FullWidthVideo = ({ data }) => {
  const {
    text,
    images,
    buttons,
    topMargin,
    bottomMargin
  } = data;
  return (
    <Section spacing={clsx(topMargin, bottomMargin ? bottomMargin : 'mb-7')}>
      {images &&
        <div className='d-flex justify-content-center position-relative'>
          {/* Background video loop */}
          <video autoPlay loop muted playsInline className={styles.videoPlayer}>
            <source src={images[0]?.file?.url} type='video/mp4'/>
          </video>
          <Container className={clsx('d-flex flex-column flex-xl-column-reverse position-absolute', styles.logoContainer)}>
            {/* Logo */}
            <Lottie animationData={btsSummitLogoAnimation} loop={true} className='d-none d-lg-block' />
            <div style={{height: 206}} className='d-lg-none'></div>
            {/* Event text */}
            {text && documentToReactComponents(JSON.parse(text.raw), {
              renderText: text =>
                text
                  .split('\n')
                  .flatMap((text, i) => [i > 0 && <br key={i} />, text]),
              renderNode: {
                [BLOCKS.UL_LIST]: (node, children) =>
                  <ul className={clsx('d-flex flex-column flex-xl-row list-unstyled', styles.listEvents)}>{children}</ul>
                ,
                [BLOCKS.LIST_ITEM]: (node, children) =>
                  <li className='py-4 py-xl-0 px-lg-4'>
                    {children}
                  </li>
                ,
                [BLOCKS.PARAGRAPH]: (node, children) => {
                  if (node.content.every(x => x.nodeType === 'text' && x.value === '')) {
                    // Fix for blank paragraph blocks adding margin
                    return <>{children}</>;
                  }
                  return (
                    <p className='fs-28 mb-0'>{children}</p>
                  )
                }
                },
              })
            }
            {buttons &&
              <div className='d-flex d-xl-none flex-column flex-sm-row justify-content-center'>
                {buttons.map(button => (
                  <Button
                    key={button.id}
                    to={button.link}
                    variant={button.variant}
                    size={button.size}
                    addClass={clsx('scale-1 mb-2 m-sm-1 p-3', button.class)}
                    copy={button.copy}
                    icon={button.icon}
                    iconSize={button.iconSize}
                    iconPosition={button.iconPosition}
                    modal={button.modal}
                  />
                ))}
              </div>
            }
          </Container>
        </div>
      }      
    </Section>
  )
}

export default FullWidthVideo
